import { render, staticRenderFns } from "./MatchingCancle.vue?vue&type=template&id=be830070&scoped=true"
import script from "./MatchingCancle.vue?vue&type=script&lang=js"
export * from "./MatchingCancle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be830070",
  null
  
)

export default component.exports